import React, { FC, useEffect, useState } from "react";
import "./style.scss";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import IrancellIcon from "../../assets/images/irancell-icon.svg";
import ShetacIcon from "../../assets/images/shetacIcon.svg";
import CardIcon from "../../assets/images/cardIcon.svg";
import HamrahAvalIcon from "../../assets/images/hamrahAvalIcon.svg";
import RightleIcon from "../../assets/images/rightelIcon.svg";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { SmartIpgChargeApi } from "../../services/api/walletCharge";
import Loader from "../../components/loader";
import { InternetBuyApi } from "../../services/api/InternetPackage";
import { RialSeparator } from "../../utils/price-separator";
import GiftPayment from "./gift";

const Payment: FC = () => {
  const [state, setState] = useState({
    loading: false,
    redirect: false,
    to: "",
  });
  const history = useHistory();

  const { type, info } = useSelector(({ payment }: any) => payment);
  let op;
  let icon;
  switch (info.operator_type_id || info.type_operator_id) {
    case 1:
      op = "ایرانسل";
      icon = IrancellIcon;
      break;
    case 2:
      op = "همراه اول";
      icon = HamrahAvalIcon;
      break;
    case 3:
      op = "رایتل";
      icon = RightleIcon;
      break;
    default:
      break;
  }

  const base_url = window.location.origin;
  console.log(base_url);


  const smartIpg = async () => {
    setState({
      ...state,
      loading: true,
    });
    if (type === 1) {
      const res = await SmartIpgChargeApi({ ...info, base_url });
      if (res) {
        setState({ ...state, loading: false });
        // dispatch(SetChargePackage({}))
        console.log("link ========> ", res);
        window.open(res, "_self");
      } else {
        setState({ loading: false, redirect: true, to: "/" });
      }
    } else {
      const res = await InternetBuyApi({ ...info, base_url });

      if (res) {
        setState({ ...state, loading: false });
        // dispatch(SetChargePackage({}))
        window.open(res["link"], "_self");
      } else {
        setState({ loading: false, redirect: true, to: "/" });
      }
    }
  };

  
  if (state.redirect) history.push(state.to);

  return (
    <Loader loading={state.loading}>
      <div className="main mb-5">
        <Grid container>
          <Grid item lg={4} className="mx-auto responsive" style={{ minWidth: '300px' , marginTop: '50px'}}>
            {/* @ts-ignore */}
            <Box className="mt-4 dir box mainBox w-100" p={6} pt={0}>
              {type === 2 ? (
                <GiftPayment />
              ) : (
                <>
                  {/* @ts-ignore */}
                  <Box
                    className="haedIcon mx-auto"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <img src={icon} width="90%" />
                  </Box>
                  <Typography className="text-center mb-5">
                    {type === 0 ? "اینترنت" : "شارژ"} {op}
                  </Typography>
                  {type === 0 && (
                    <Paper className="text-center paper mt-3 small">
                      {" "}
                      {info.package_title}{" "}
                    </Paper>
                  )}
                  <Paper className="text-center paper mt-3 ">
                    مبلغ {RialSeparator(info.amount)} ریال
                    <br />
                    <p className="small text-muted">با احتساب 9 درصد مالیات</p>
                  </Paper>
                  <Paper className="text-center paper mt-3">
                    <span>شماره همراه :</span>
                    <span>{info.mobile_number}</span>
                  </Paper>
                </>
              )}

              {/* @ts-ignore */}
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  {/* @ts-ignore */}
                  <Box>
                    <Button
                      variant="contained"
                      className="success mt-4"
                      onClick={() => smartIpg()}
                      endIcon={
                        <img
                          src={CardIcon}
                          width="40px"
                          className="ms-auto abs icon"
                        />
                      }
                    >
                      پرداخت
                    </Button>
                  </Box>
                </Grid>
                <Grid item xs={4}>
                  {/* @ts-ignore */}
                  <Box>
                    <Button
                      variant="contained"
                      className="back endBtn mt-4"
                      onClick={() =>
                        setState({ ...state, redirect: true, to: "/" })
                      }
                    >
                      بازگشت
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </div>
    </Loader>
  );
};

export default Payment;
